// extracted by mini-css-extract-plugin
module.exports = {"pageTop":"PageTitle_pageTop__J1m3J","backBtn":"PageTitle_backBtn__1IpB9"};